(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lightbox"] && !Shopify.designMode) return;
  try {
    class Lightbox {
  constructor() {
    this.lightbox = document.getElementById('lightbox');
    this.lightboxImage = this.lightbox?.querySelector('.lightbox__image');
    this.lightboxPlaceholder = this.lightbox?.querySelector('.lightbox__image-placeholder');
    this.lightboxClose = this.lightbox?.querySelector('.lightbox__close');
    this.lightboxPrev = this.lightbox?.querySelector('.lightbox__nav--prev');
    this.lightboxNext = this.lightbox?.querySelector('.lightbox__nav--next');
    this.lightboxCurrent = this.lightbox?.querySelector('.lightbox__current');
    this.lightboxTotal = this.lightbox?.querySelector('.lightbox__total');
    
    if (!this.lightbox || !this.lightboxImage || !this.lightboxPlaceholder || !this.lightboxClose) return;
    
    this.images = [];
    this.currentIndex = 0;
    this.loadingImage = null;
    
    this.init();
  }
  
  init() {
    // Add click handlers to all images with lightbox data attributes
    document.addEventListener('click', (e) => {
      const image = e.target.closest('[data-lightbox-src]');
      if (image) {
        e.preventDefault();
        this.open(image);
      }
    });
    
    // Close lightbox handlers
    this.lightboxClose.addEventListener('click', () => this.close());
    this.lightbox.addEventListener('click', (e) => {
      // Close when clicking on the overlay, content area, or lightbox container
      // but not when clicking on the image, close button, or navigation buttons
      if (e.target === this.lightbox || 
          e.target.classList.contains('lightbox__overlay') ||
          e.target.classList.contains('lightbox__content')) {
        this.close();
      }
    });
    
    // Navigation handlers
    this.lightboxPrev?.addEventListener('click', () => this.previous());
    this.lightboxNext?.addEventListener('click', () => this.next());
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.lightbox.style.display === 'none') return;
      
      switch (e.key) {
        case 'Escape':
          this.close();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          this.previous();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.next();
          break;
      }
    });
  }
  
  open(image) {
    // Find all images in the same gallery
    const gallery = image.closest('.gallery__grid');
    if (gallery) {
      this.images = Array.from(gallery.querySelectorAll('[data-lightbox-src]'));
      this.currentIndex = this.images.indexOf(image);
    } else {
      // Fallback to just the clicked image
      this.images = [image];
      this.currentIndex = 0;
    }
    
    this.updateDisplay();
    this.lightbox.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  close() {
    this.lightbox.style.display = 'none';
    document.body.style.overflow = '';
    this.images = [];
    this.currentIndex = 0;
  }
  
  previous() {
    if (this.images.length <= 1) return;
    
    this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.images.length - 1;
    this.updateDisplay();
  }
  
  next() {
    if (this.images.length <= 1) return;
    
    this.currentIndex = this.currentIndex < this.images.length - 1 ? this.currentIndex + 1 : 0;
    this.updateDisplay();
  }
  
  updateDisplay() {
    if (this.images.length === 0) return;
    
    const currentImage = this.images[this.currentIndex];
    const fullSrc = currentImage.getAttribute('data-lightbox-src');
    const placeholderSrc = currentImage.getAttribute('data-lightbox-placeholder') || this.#generatePlaceholderSrc(fullSrc);
    const alt = currentImage.getAttribute('data-lightbox-alt') || '';
    
    // Cancel any ongoing image load
    if (this.loadingImage) {
      this.loadingImage.onload = null;
      this.loadingImage.onerror = null;
      this.loadingImage = null;
    }
    
    // Reset states
    this.lightboxImage.classList.remove('lightbox__image--loaded');
    this.lightboxPlaceholder.classList.remove('lightbox__image-placeholder--hidden');
    
    // Set placeholder immediately (small, blurred version)
    this.lightboxPlaceholder.src = placeholderSrc;
    this.lightboxPlaceholder.alt = alt;
    
    // Clear full image src to prevent loading until we're ready
    this.lightboxImage.src = '';
    this.lightboxImage.alt = alt;
    
    // Preload full resolution image
    this.#loadFullImage(fullSrc);
    
    // Update counter
    if (this.lightboxCurrent) {
      this.lightboxCurrent.textContent = this.currentIndex + 1;
    }
    if (this.lightboxTotal) {
      this.lightboxTotal.textContent = this.images.length;
    }
    
    // Update navigation button states and visibility
    if (this.lightboxPrev) {
      this.lightboxPrev.disabled = this.images.length <= 1;
    }
    if (this.lightboxNext) {
      this.lightboxNext.disabled = this.images.length <= 1;
    }
    
    // Add/remove class to hide arrows when there's only one item
    if (this.images.length <= 1) {
      this.lightbox.classList.add('lightbox--single-item');
    } else {
      this.lightbox.classList.remove('lightbox--single-item');
    }
  }
  
  #loadFullImage(src) {
    // Create a new Image object to preload
    this.loadingImage = new Image();
    
    this.loadingImage.onload = () => {
      // Once loaded, set the src and show the full image
      this.lightboxImage.src = src;
      this.lightboxImage.classList.add('lightbox__image--loaded');
      this.lightboxPlaceholder.classList.add('lightbox__image-placeholder--hidden');
      this.loadingImage = null;
    };
    
    this.loadingImage.onerror = () => {
      // On error, keep showing placeholder
      this.loadingImage = null;
    };
    
    // Start loading
    this.loadingImage.src = src;
  }
  
  #generatePlaceholderSrc(fullSrc) {
    if (!fullSrc) return '';
    
    // If it's a Shopify image URL, generate a small version
    // Shopify image URLs can be modified with size parameters
    if (fullSrc.includes('cdn.shopify.com') || fullSrc.includes('shopifycdn.com')) {
      // Try to add size parameter for a small version (e.g., 100x100)
      const url = new URL(fullSrc);
      url.searchParams.set('width', '100');
      return url.toString();
    }
    
    // For other URLs, return as-is (will be blurred by CSS)
    return fullSrc;
  }
}

// Initialize lightbox when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new Lightbox());
} else {
  new Lightbox();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    class ProductFormVariantSelector {
  constructor(form) {
    this.form = form;
    this.variantSelects = form.querySelectorAll('.product-form__option-select');
    this.variantIdInput = form.querySelector('#product-variant-id');
    this.submitButton = form.querySelector('.product-form__submit');
    this.variantsData = this.#parseVariantsData();
    
    if (!this.variantIdInput || this.variantSelects.length === 0) return;
    
    this.#initialize();
    this.#attachListeners();
  }

  #parseVariantsData() {
    const variantsContainer = this.form.querySelector('.product-form__variants');
    if (!variantsContainer) return new Map();
    
    const dataString = variantsContainer.getAttribute('data-variants');
    if (!dataString) return new Map();
    
    const variantsMap = new Map();
    const entries = dataString.split(',');
    
    for (const entry of entries) {
      const [optionsString, variantId, available] = entry.split(':');
      if (optionsString && variantId) {
        variantsMap.set(optionsString, {
          id: variantId,
          available: available === 'true'
        });
      }
    }
    
    return variantsMap;
  }

  #initialize() {
    this.#updateVariantFromSelection();
  }

  #attachListeners() {
    for (const select of this.variantSelects) {
      select.addEventListener('change', () => {
        this.#updateVariantFromSelection();
      });
    }
  }

  #updateVariantFromSelection() {
    const selectedOptions = [];
    
    for (const select of this.variantSelects) {
      const value = select.value;
      if (!value) {
        this.variantIdInput.value = '';
        this.#updateSubmitButton(false);
        return;
      }
      selectedOptions.push(value);
    }
    
    const optionsKey = selectedOptions.join('|');
    const matchedVariant = this.variantsData.get(optionsKey);
    
    if (matchedVariant) {
      this.variantIdInput.value = matchedVariant.id;
      this.#updateSubmitButton(matchedVariant.available);
    } else {
      this.variantIdInput.value = '';
      this.#updateSubmitButton(false);
    }
  }

  #updateSubmitButton(available) {
    if (!this.submitButton) return;
    
    this.submitButton.disabled = !available;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    new ProductFormVariantSelector(productForm);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.collection-products');
  if (!container) return;

  const products = container.querySelectorAll('.collection-product');
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      container.classList.add('collection-products--visible');
      for (const [index, product] of products.entries()) {
        product.style.setProperty('--fade-delay', `${index * 0.1}s`);
      }
      observer.disconnect();
    }
  }, { threshold: 0.1 });

  observer.observe(container);
  } catch(e) { console.error(e); }
})();

})();
